<template>
  <div class="modal_wrapper active">
    <div class="modal_window white_box create_report_modal">
      <button
        class="close_modal close_btn"
        @click="closeModal()"
      >
        <svg
          fill="none"
          height="32"
          viewBox="0 0 32 32"
          width="32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25 7L7 25"
            stroke="#040707"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
          <path
            d="M25 25L7 7"
            stroke="#040707"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
        </svg>
      </button>

      <h3 class="heading_h4 font_bold mb_16">
        {{ widgetModal.widget ? 'Edit' : 'Create' }} Google Search Console
        Widget
      </h3>

      <div :class="'section_wrap '+(settings === 'widget' ? 'open' : '')">
        <div
          class="section_head"
          @click="(settings === 'widget' ? settings = '' : settings = 'widget')"
        >
          <h3 class="section_heading">
            Widget Settings
          </h3>
          <i class="icon arrow_down_icon caret" />
        </div>
        <accordion-transition>
          <div
            v-if="settings === 'widget'"
            class="section_body"
          >
            <custom-input
              v-model="widget.name"
              label="Widget title"
              placeholder="Enter a title for the widget"
              width="full"
            />

            <custom-select
              v-model="widget.attributes.type"
              :options="{
                'line-chart': 'Line chart',
                'area-chart': 'Area chart',
                'stat-boxes': 'Stat boxes',
              }"
              label="Widget type"
              width="half"
            />

            <custom-select
              v-model="widget.attributes.options.useDatesFrom"
              :options="{
                'report': 'Report date range',
                'custom': 'Custom date range',
              }"
              label="Use date range"
              width="half"
            />

            <div
              v-if="widget.attributes.options.useDatesFrom === 'custom'"
              class="custom_daterange"
            >
              <custom-input
                :disabled="true"
                :placeholder="selectedDateRange"
                :width="widget.attributes.options.dates.compRange ? 'third' : 'half'"
                label="Date range"
              />

              <custom-input
                v-if="widget.attributes.options.dates.compRange"
                :disabled="true"
                :placeholder="selectedCompRange"
                label="Comparison date range"
                width="third"
              />

              <button
                :class="'btn secondary_btn open-datepicker '+(widget.attributes.options.dates.compRange ? 'third' : 'half')"
                @click="datepicker = true"
              >
                <span>Select Date Range</span>
              </button>

              <date-range-picker
                v-if="datepicker"
                v-model:compFromDate="widget.attributes.options.dates.compFromDate"
                v-model:compRange="widget.attributes.options.dates.compRange"
                v-model:compToDate="widget.attributes.options.dates.compToDate"
                v-model:dateRange="widget.attributes.options.dates.dateRange"
                v-model:fromDate="widget.attributes.options.dates.fromDate"
                v-model:toDate="widget.attributes.options.dates.toDate"
                @close="datepicker = false"
              />
            </div>

            <custom-select
              v-model="widget.attributes.options.metric"
              :options="{
                'ALL' : 'Clicks & Impressions',
                'CLICKS' : 'Clicks',
                'IMPRESSIONS' : 'Impressions',
              }"
              label="Select Metric"
              width="full"
            />
          </div>
        </accordion-transition>
      </div>

      <div
        v-if="widget.attributes.type.includes('chart')"
        :class="'section_wrap '+(settings === 'chart' ? 'open' : '')"
      >
        <div
          class="section_head"
          @click="(settings === 'chart' ? settings = '' : settings = 'chart')"
        >
          <h3 class="section_heading">
            Chart Settings <small>(optional)</small>
          </h3>
          <i class="icon arrow_down_icon caret" />
        </div>
        <accordion-transition>
          <div
            v-if="settings === 'chart'"
            class="section_body"
          >
            <custom-select
              v-model="widget.attributes.options.useColorsFrom"
              :options="{
                'report' : 'Use Report Colors',
                'custom' : 'Use Custom Colors',
              }"
              label="Chart Colors"
              width="full"
            />

            <custom-color-multiselect
              v-if="widget.attributes.options.useColorsFrom === 'custom'"
              v-model="widget.attributes.chartOptions.colors"
              label="Custom Colors"
              width="full"
            />

            <div
              v-if="widget.attributes.options.dates.compRange || widget.attributes.options.metric === 'ALL'"
              class="chart_legend"
            >
              <div class="toggles">
                <custom-toggle
                  v-model="widget.attributes.chartOptions.legend.show"
                  label="Show Legend"
                  width="quarter"
                />
              </div>

              <custom-select
                v-if="widget.attributes.chartOptions.legend.show"
                v-model="widget.attributes.chartOptions.legend.position"
                :options="{
                  'bottom': 'Bottom',
                  'top': 'Top',
                  'right': 'Right',
                  'left': 'Left'
                }"
                label="Legend position"
                width="half"
              />

              <custom-select
                v-if="widget.attributes.chartOptions.legend.show"
                v-model="widget.attributes.chartOptions.legend.horizontalAlign"
                :options="{
                  'center': 'Centre',
                  'right': 'Right',
                  'left': 'Left'
                }"
                label="Legend align"
                width="half"
              />
            </div>

            <div class="toggles">
              <custom-toggle
                v-model="widget.attributes.chartOptions.dataLabels.enabled"
                label="Show Data Labels"
                width="quarter"
              />

              <custom-toggle
                v-model="widget.attributes.chartOptions.grid.xaxis.lines.show"
                label="Show X Axis Grid"
                width="quarter"
              />

              <custom-toggle
                v-model="widget.attributes.chartOptions.grid.yaxis.lines.show"
                label="Show Y Axis Grid"
                width="quarter"
              />
            </div>
          </div>
        </accordion-transition>
      </div>

      <div class="flex items-center section_modal_footer">
        <button
          class="btn btn_md secondary_btn close_modal ml_auto mr_8"
          @click="closeModal()"
        >
          <span>Cancel</span>
        </button>
        <button
          class="btn btn_md primary_btn"
          @click="save()"
        >
          <span>{{ widgetModal.widget ? 'Update' : 'Create' }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import _ from 'lodash';
import {mapActions, mapState} from 'vuex';
import CustomInput from '../../global/forms/CustomInput.vue';
import CustomSelect from '../../global/forms/CustomSelect.vue';
import CustomColorMultiselect from '../../global/forms/CustomColorMultiselect.vue';
import CustomToggle from '../../global/forms/CustomToggle.vue';
import DateRangePicker from '../../global/forms/DateRangePicker.vue';
import AccordionTransition from '../../global/transitions/AccordionTransition.vue';

export default {
  components: {
    CustomInput,
    CustomSelect,
    CustomColorMultiselect,
    CustomToggle,
    DateRangePicker,
    AccordionTransition
  },
  emits: ['refresh-widget'],
  data() {
    return {
      datepicker: false,
      settings: 'widget',
      widget: {
        id: `widget-gsc-${Date.now()}`,
        name: 'Google Search Console Widget',
        type: 'gsc',
        w: 6,
        h: 25,
        frozen: false,
        content: `<div id="widget-gsc-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
        attributes: {
          type: 'line-chart',
          options: {
            metric: 'ALL',
            useDatesFrom: 'report',
            useColorsFrom: 'report',
            dates: {
              dateRange: null,
              compRange: null,
              fromDate: '',
              toDate: '',
              compFromDate: '',
              compToDate: ''
            }
          },
          chartOptions: {
            chart: {
              id: `widget-gsc-${Date.now()}`,
              animations: {
                enabled: false
              }
            },
            title: {
              text: '',
              align: 'center'
            },
            colors: [],
            grid: {
              xaxis: {
                lines: {
                  show: false
                }
              },
              yaxis: {
                lines: {
                  show: false
                }
              },
            },
            legend: {
              show: true,
              position: 'top',
              horizontalAlign: 'center',
            },
            dataLabels: {
              enabled: false
            }
          }
        }
      }
    }
  },
  computed: {
    ...mapState('report', ['report']),
    ...mapState(['widgetModal']),
    selectedDateRange() {
      if (this.widget.attributes.options.dates.fromDate && this.widget.attributes.options.dates.toDate) {
        let from = moment(this.widget.attributes.options.dates.fromDate, 'YYYY-MM-DD').format(this.report.date_format);
        let to = moment(this.widget.attributes.options.dates.toDate, 'YYYY-MM-DD').format(this.report.date_format);
        return from + ' - ' + to;
      }

      return 'Please select dates';
    },
    selectedCompRange() {
      if (this.widget.attributes.options.dates.compFromDate && this.widget.attributes.options.dates.compToDate) {
        let from = moment(this.widget.attributes.options.dates.compFromDate).format(this.report.date_format);
        let to = moment(this.widget.attributes.options.dates.compToDate).format(this.report.date_format);
        return from + ' - ' + to;
      }
      return 'Please select dates';
    }
  },
  watch: {
    'widget.attributes.options.useDatesFrom': {
      handler(a) {
        if (a === 'report') {
          this.updateToReportDates();
        }
      }
    }

  },
  beforeMount() {
    if (this.widgetModal.widget) _.merge(this.widget, this.widgetModal.widget);
  },
  mounted() {
    this.updateToReportDates();
  },
  methods: {
    ...mapActions('pages', ['addWidget', 'updateWidget']),
    ...mapActions('widgetModal', ['closeModal']),
    updateToReportDates() {
      if (this.widget.attributes.options.useDatesFrom === 'report') {
        this.widget.attributes.options.dates.dateRange = this.report.date_range;
        this.widget.attributes.options.dates.compRange = this.report.comp_range;
        this.widget.attributes.options.dates.fromDate = this.report.from_date;
        this.widget.attributes.options.dates.toDate = this.report.to_date;
        this.widget.attributes.options.dates.compFromDate = this.report.comp_from_date;
        this.widget.attributes.options.dates.compToDate = this.report.comp_to_date;
      }
    },
    async save() {
      if (!this.widget.resized && !this.widgetModal.widget) {
        if (this.widget.attributes.type.includes('table') || this.widget.attributes.type.includes('stat-boxes')) this.widget.w = 12;
      }

      // Prep a payload for the vuex action
      const payload = {
        widget: this.widget,
        pageId: this.widgetModal.pageId,
      }

      // Check if we're creating a new widget or editing one
      if (!this.widgetModal.widget) {
        // Save the new pages layout (refreshes store pages)
        await this.addWidget(payload);
      } else {
        // Update the widget
        payload.widget.resized = false;
        await this.updateWidget(payload);
      }

      // Emit to trigger widget refresh, then close the modal
      this.$emit('refresh-widget', {pageId: this.widgetModal.pageId, widget: this.widget});
      this.closeModal();
    },
  },
}
</script>

<style scoped src="../../../../reports/css/modal.css" />
